/* eslint-disable indent */
    'use strict';
    var trackingUtils = require('../modules/utils/tracking.utils');
    const Modal = require('../modules/ui/modal');
    const flightChangeFreeUtil = require('../modules/utils/flight_change_free');

    const insuranceCatalogueCollection = require('../modules/collections/insurance_catalogue.collection').getInstance();
    const FLEXIBILITY_DISRUPTION_MODAL_CLASS_WRAPPER = 'flexibility_disruption_popup';
    const FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES = 'flexibility_disruption';
    const FLIGHT_CHANGE_FREE_GENERIC_TEMPLATES = 'flight_change_free';

    Odigeo.defineWidget('flight_details', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            dataURL: null,
            passengersInfoUrl: 'shortPaxInfo',

            getDataRequestSettings: function() {
                return {
                    type: 'GET',
                    cache: false,
                    success: Odigeo._.bind(this.requestSuccessHandler, this),
                    error: Odigeo._.bind(this.requestErrorHandler, this),
                };
            },

            url: function() {
                return Odigeo.Settings.getProperty('widgetPartUrlFormatter')(this.widget.name, this.passengersInfoUrl);
            },

            requestSuccessHandler: function(msg) {
                this.widget.view.updatePassengers(msg);
            },
            requestErrorHandler: function(xhr) {
                Odigeo.trigger(this.widget.id + ':requestError', xhr);
            },
            refreshPaxData: function() {
                this.isEmptyData = false;
                this.refresh();
            },
        }),

        viewClass: Odigeo.View.extend({
            flightTemplate: null,
            popup: null,
            expandPanelDuration: 400,
            isExpanded: false,
            isInProcess: false,
            extraHeight: 0,
            isDomBinded: false,

            init: function() {
                this.widget.options = Odigeo.parseOptions(this.widget.options);
                Odigeo._.templateSettings = {
                    interpolate: /\{\{(.+?)\}\}/g,
                };
                this.flightTemplate = Odigeo._.template(this.$cachedSelectors.expandArea.length !== 0 ?
                    this.$cachedSelectors.expandArea.find('.flight_template').html() : '<div></div>');
                this.$cachedSelectors.itineraryDetails.addClass('expanded');
                this.$cachedSelectors.headRow.addClass(this.widget.options.inSideSummary ? 'od-side-summary-row' : '');

                if (this.model.widget.options.notAnimate) {
                    this.$cachedSelectors.flightDetails.removeClass('hidden');
                } else {
                    this.enhanceCollapsive();
                    this.bindToDom();
                }

                if (!this.model.widget.options.showPaxInfo) {
                    this.fillPax();
                }
                this.prepareAccommodationCancelPolicies();

                const shouldShowFlightChangeFreeMessage = (Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isPrimeDays)
                    && flightChangeFreeUtil.isSelectedFlightChangeableForFree();
                if (shouldShowFlightChangeFreeMessage) {
                    this.renderFlightChangeFreeBanner();
                } else {
                    this.renderFlexibilityDisruptionBanner();
                }

                this.widget.view.toggleViewPanel();
            },
            events: {
                'tap .accommodation_toggle_details': 'accommodationToggleDetails',
                'tap .expand_area_text': 'toggleViewPanel',
                'tap @flexibilityDisruptionModalIcon': 'openFlexibilityDisruptionModal',
            },

            selectors: {
                flightDetails: '.flight_details',
                headRow: '.head_row',
                expandArea: '.expand_area',
                expandAreaText: '.expand_area_text',
                paxSummary: '.pax_summary',
                paxCount: '.pax_count',
                paxList: '.pax_list',
                itineraryDetails: '.itinerary_details',
                lightboxContent: '.flight_details_content_lightbox',
                roomDetailsPopup: '.room_details_popup',
                owcSpecialRules: '.owc_special_rules',
                flexibilityDisruptionBanner: '.flexibility_disruption_banner',
                flightChangeFreeBanner: '.flight_change_free_banner',
                flexibilityDisruptionModalIcon: '.flexibility_disruption_modal_icon',
            },

            bindToDom: function() {
                if (!this.isDomBinded) {
                    this.isDomBinded = true;
                }
            },

            renderFlexibilityDisruptionBanner() {
                insuranceCatalogueCollection.getLoadedPromise().then(Odigeo._.bind((loaded) => {
                    if (loaded && insuranceCatalogueCollection.isCancellationFree()) {
                        Odigeo.Templates.getGenericTemplates([FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES])
                            .then(Odigeo._.bind(function(templates) {
                                if (Odigeo._.isObject(templates)) {
                                    const flexibilityDisruptionTemplates = Odigeo._.get(templates, FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES);
                                    const flexibilityDisruptionTemplatesKeys =
                                        templates.getStaticTemplatesKeys(FLEXIBILITY_DISRUPTION_GENERIC_TEMPLATES);

                                    this.initFlexibilityDisruptionModal(flexibilityDisruptionTemplates, flexibilityDisruptionTemplatesKeys);
                                    this.setFlexibilityDisruptionBanner(flexibilityDisruptionTemplates, flexibilityDisruptionTemplatesKeys);
                                }
                            }, this));
                    }
                }, this));
            },

            renderFlightChangeFreeBanner() {
                Odigeo.Templates.getGenericTemplates([FLIGHT_CHANGE_FREE_GENERIC_TEMPLATES])
                    .then(Odigeo._.bind(function(templates) {
                        if (Odigeo._.isObject(templates)) {
                            const flightChangeFreeTemplates = Odigeo._.get(templates, FLIGHT_CHANGE_FREE_GENERIC_TEMPLATES);
                            const flightChangeFreeTemplatesKeys = templates.getStaticTemplatesKeys(FLIGHT_CHANGE_FREE_GENERIC_TEMPLATES);
                            this.setFlightChangeFreeBanner(flightChangeFreeTemplates, flightChangeFreeTemplatesKeys);
                        }
                    }, this));
            },

            trackWhenOnClick() {
                trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_when_pag:pax');
            },

            trackWhatOnClick() {
                trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_what_pag:pax');
            },

            trackHowOnClick() {
                trackingUtils.trackEvent('free-cancellation_nag', 'free-cancellation_open-info_how_pag:pax');
            },

            initFlexibilityDisruptionModal(flexibilityDisruptionTemplates, flexibilityDisruptionTemplatesKeys) {
                const modalTemplateBuilter = Odigeo._.get(flexibilityDisruptionTemplates, 'modals/modal', Odigeo._.noop);
                const modalContentTemplateBuilder = Odigeo._.get(flexibilityDisruptionTemplates, 'modals/content', Odigeo._.noop);
                const $modalContainer = $(`.${FLEXIBILITY_DISRUPTION_MODAL_CLASS_WRAPPER}`);

                this.modal = new Modal($modalContainer, {
                    content: modalContentTemplateBuilder(flexibilityDisruptionTemplatesKeys),
                    button: Odigeo._.get(flexibilityDisruptionTemplatesKeys, 'flexibilityDisruptionPopUpCloseButton', ''),
                },
                {
                    template: modalTemplateBuilter,
                    fillThePage: false,
                    preventContainerTap: false,
                    open: {
                        analytics: {
                            action: 'free-cancellation_onload-nag',
                            label: 'free-cancellation_onload-nag_pag:pax',
                        },
                    },
                    close: {
                        analytics: {
                            action: 'free-cancellation_onload-nag',
                            label: 'free-cancellation_close-nag_pag:pax',
                        },
                    },
                    button: {
                        analytics: {
                            action: 'free-cancellation_onload-nag',
                            label: 'free-cancellation_close-info_pag:pax',
                        },
                    },
                });
                $modalContainer.removeClass('odf-hidden');
                $modalContainer.on('click', this.trackWhenOnClick);
                $modalContainer.on('click', this.trackWhatOnClick);
                $modalContainer.on('click', this.trackHowOnClick);
            },

            setFlexibilityDisruptionBanner(templates, keys) {
                const template = Odigeo._.get(templates, 'flexibilityDisruptionBanner', Odigeo._.noop);
                const content = template({texts: keys});
                this.$cachedSelectors.flexibilityDisruptionBanner.html(content);
                this.$cachedSelectors.flexibilityDisruptionBanner.removeClass('odf-hidden');
            },

            setFlightChangeFreeBanner(templates, keys) {
                const template = Odigeo._.get(templates, 'flightChangeFreeBanner', Odigeo._.noop);
                const content = template({texts: keys});
                this.$cachedSelectors.flightChangeFreeBanner.html(content);
                this.$cachedSelectors.flightChangeFreeBanner.removeClass('odf-hidden');
            },


            openFlexibilityDisruptionModal() {
                trackingUtils.trackEvent('free-cancellation_trip', 'free-cancellation_more-trip_pag:pax');
                this.modal.then((flexibilityDisruptionModal) => {
                    flexibilityDisruptionModal.open(true, true);
                });
            },

            accommodationToggleDetails: function(ev) {
                var optionsDetails = Odigeo._.clone($(ev.currentTarget).data('details'));
                var label = $(ev.currentTarget).data('label');
                var target = Odigeo.History.getPageNameFromFragment() + '_flights_container';
                var isOpen = this.$('#' + target).hasClass('open');

                ev.stopPropagation();
                optionsDetails.target = target;
                Odigeo.trigger(this.widget.id + ':toggleDetails', optionsDetails);

                if (!isOpen && label) {
                    trackingUtils.trackEvent('trip_information', label);
                }
            },

            prepareAccommodationCancelPolicies: function() {
                Odigeo._.each(this.$el.find(this.selectors.roomDetailsPopup), function($details) {
                    Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), $details, {
                        events: {
                            tap: true,
                        },
                    });
                });
            },

            enhanceModalDialog: function() {
                this.popup = Odigeo.UIElements.createDialog({
                    content: this.$cachedSelectors.lightboxContent.html(),
                    dialogClasses: 'od-dialog-flight-details',
                    hasCloseButton: true,
                    closeOnTapOuterBox: true,
                    closeOnNavigate: true,
                });
            },

            showInModalDialog: function() {
                this.enhanceModalDialog();
                Odigeo.UIElements.showDialog(this.popup);
            },

            enhanceCollapsive: function() {
                Odigeo.UIElements.collapsive.enhance(this.$cachedSelectors.flightDetails,
                    {
                        expandPanelDuration: this.expandPanelDuration,
                        collapsePanelDuration: this.expandPanelDuration,
                        extraHeight: this.extraHeight,
                        googleAnalyticsOnOpen: {
                            type: 'trackEvent',
                            data: {
                                page: Odigeo.History.getPageNameFromFragment(),
                                action: 'trip_information',
                                label: 'open_trip_details',
                            },
                        },
                        googleAnalyticsOnOpenAutomatic: {
                            type: 'trackEvent',
                            data: {
                                page: Odigeo.History.getPageNameFromFragment(),
                                action: 'trip_information',
                                label: 'onload_trip_information_displayed',
                            },
                        }, triggerLauncher: this.widget.id, triggerEvents: true,
                    }
                );
                Odigeo.on(this.widget.id + ':panelExpanded ' + this.widget.id + ':panelCollapsed', Odigeo._.bind(function() {
                    this.isInProcess = false;
                }, this));
            },

            fillPax: function() {
                var info = Odigeo.Session.get('booking_pax_list');
                var paxList;
                if (info) {
                    info = JSON.parse(info);
                    this.$cachedSelectors.paxCount.text('(' + info.length + ')');
                    paxList = Odigeo._.map(info, function(pax) {
                        return pax.name + ' ' + (pax.firstLastName || pax.lastName);
                    }).join(', ');
                    this.$cachedSelectors.paxList.text(paxList);
                    this.$cachedSelectors.paxSummary.removeClass('hidden');
                }
            },

            paxDetailsUpdated: function() {
                Odigeo._.each(this.$widget.find('.baggage_repricing'), function(popup) {
                    Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), popup, {
                        events: {
                            tap: true,
                        },
                    });
                });
            },

            toggleViewPanel: function(event, hasToTrack) {
                const $expandArea = this.$cachedSelectors.expandAreaText;
                if (!this.isInProcess) {
                    this.isExpanded = !this.isExpanded;
                    this.$cachedSelectors.flightDetails.trigger('togglePanel', {isOpenedAutomatic: false, hasToTrack: hasToTrack});
                    $expandArea.text($expandArea.data(this.isExpanded ? 'open' : 'hide'));
                    this.$cachedSelectors.expandArea.toggleClass('open', this.isExpanded);
                    Odigeo.trigger(this.widget.id + ':closeAccommodation');
                    this.isInProcess = true;
                }
            },

            updatePassengers: function(data) {
                this.$cachedSelectors.paxList.html(data);
            },
        }),
        dic: {
            fillPax: 'fillPax',
            toggleViewPanel: 'toggleViewPanel',
            paxDetailsUpdated: 'paxDetailsUpdated',
        },

        execute: function(func) {
            var args = Odigeo._.rest(arguments);
            if (this.view[this.dic[func]]) {
                this.view[this.dic[func]].apply(this.view, args);
            }
            return this;
        },
    }));
